import { GlobalRedFlagBanner } from "@/components/workflow/ui";
import StepSymptoms from "@/components/workflow/StepSymptoms";
import StepFollowup from "@/components/workflow/StepFollowup";
import StepTentative from "@/components/workflow/StepTentative";
import StepExamination from "@/components/workflow/StepExamination";
import StepDifferentials from "@/components/workflow/StepDifferentials";
import StepInvestigations from "@/components/workflow/StepInvestigations";
import StepFinal from "@/components/workflow/StepFinal";

// Renders the active clinical step. Kept separate so the page shell stays thin.
export default function WorkflowStepRouter({ wf, user }) {
  const { step } = wf;
  return (
    <>
      {step >= 2 && wf.tentative?.emergency_flag && (
        <GlobalRedFlagBanner reason={wf.tentative.emergency_reason} />
      )}

      {step === 0 && (
        <StepSymptoms patient={wf.patient} updPatient={wf.updPatient} isPediatric={wf.isPediatric} onSubmit={wf.submitSymptoms} />
      )}

      {step === 1 && wf.questions && (
        <StepFollowup questions={wf.questions} answers={wf.answers} setAnswers={wf.setAnswers} reminded={wf.answersReminded} addSnapshotToNotes={wf.addSnapshotToNotes} onBack={() => wf.setStep(0)} onNext={wf.submitAnswers} />
      )}

      {step === 2 && wf.tentative && (
        <StepTentative tentative={wf.tentative} onBack={() => wf.setStep(1)} onNext={wf.toExamination} />
      )}

      {step === 3 && wf.signs && (
        <StepExamination
          signs={wf.signs} signResp={wf.signResp} setSignResp={wf.setSignResp}
          findings={wf.findings} setFindings={wf.setFindings} vitalCfg={wf.vitalCfg}
          isPediatric={wf.isPediatric} ageYears={wf.ageYears} patient={wf.patient}
          signsReminded={wf.signsReminded} addSnapshotToNotes={wf.addSnapshotToNotes}
          setScores={wf.setScores} onBack={() => wf.setStep(2)} onSubmit={wf.submitFindings}
        />
      )}

      {step === 4 && wf.differentials && (
        <StepDifferentials differentials={wf.differentials} onBack={() => wf.setStep(3)} onNext={wf.orderInvestigations} />
      )}

      {step === 5 && wf.investigations && (
        <StepInvestigations
          investigations={wf.investigations} reports={wf.reports} setReports={wf.setReports}
          imaging={wf.imaging} setImaging={wf.setImaging} onBack={() => wf.setStep(4)} onNext={wf.submitReports}
        />
      )}

      {step === 6 && wf.final && (
        <StepFinal
          final={wf.final} scores={wf.scores} user={user}
          downloading={wf.downloading} downloadingRx={wf.downloadingRx} downloadingSheet={wf.downloadingSheet} savingCase={wf.savingCase} savedId={wf.savedId}
          downloadPdf={wf.downloadPdf} downloadRx={wf.downloadRx} downloadCaseSheet={wf.downloadCaseSheet} saveCase={wf.saveCase} reset={wf.reset}
        />
      )}
    </>
  );
}
